import DateInput from "../../DateInput";
import { changeDepartingDate, selectFormValidity } from "../../../searchFlightsSlice";
import React from "react";
import { useAppDispatch, useAppSelector } from "../../../../../app/hooks";
import { useTranslation } from "react-i18next";

function SFODateInput() {
  const dispatch = useAppDispatch();
  const { t } = useTranslation();
  const departingDate = useAppSelector(
    (state) => state.searchFlights.form.departingDate
  );
  const disabled = useAppSelector((state) => state.searchFlights.form.disabled);
  const { departingDateFilled, departingDateBeforeReturningDate } =
    useAppSelector(selectFormValidity);
  const startingDay = useAppSelector(
    (state) => state.config.components.Inputs.RequestDate.startingDay
  )
  return (
    <div className="column sfo-date pl-0 is-one-fifth">
      <DateInput
        id="departing-date-input"
        title={t("SFO_DATE_SEARCH_TITLE")}
        date={departingDate ? new Date(departingDate) : null}
        onDateSelect={(date) =>
          dispatch(changeDepartingDate(date && date.getTime()))
        }
        inputLabel={t("SFO_INPUT_LABEL_DATE")}
        disabled={disabled}
        error={
          departingDateFilled
            ? departingDateBeforeReturningDate
              ? null
              : t("SEARCH_ALERT_OUTBOUND_DATE")
            : t("SEARCH_ALERT_OUTBOUND_DATE_REQUIRED")
        }
        startingDay={startingDay}
      />
    </div>
  );
}

export default SFODateInput;
